import React from 'react'

function Information() {
    
  return (
    <div>
       

  

       
    
    </div>
  )
}

export default Information
